import { Card, DatePicker } from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import React, { createContext, useContext, useEffect, useState } from "react";
import { SettingContext } from "../../routes";
import CustomHeader from "../common/Header";
import { Chart1 } from "./Chart1";
import { Chart2 } from "./Chart2";
import { dateRangePresets } from "../../services/util";
dayjs.extend(customParseFormat);

const { RangePicker } = DatePicker;
const ReservationAnalyticsContext = createContext();

function ReservationAnalytics() {
    const { setSelectedHotelType } = useContext(SettingContext);
    useEffect(() => {
        setSelectedHotelType("operation");
        return () => {
            setSelectedHotelType("all");
        };
    }, []);

    const [selectedDates, setSelectedDates] = useState([
        dayjs()
            .subtract(7, "days")
            .startOf("day")
            .format("YYYY/MM/DD HH:MM:SS"),
        dayjs()
            .subtract(1, "days")
            .startOf("day")
            .format("YYYY/MM/DD HH:MM:SS"),
    ]);

    function handleDateChange(e) {
        let start_date =
            e !== null ? dayjs(e[0]).startOf("day") : selectedDates[0];
        let end_date =
            e !== null ? dayjs(e[1]).startOf("day") : selectedDates[1];

        // set the default value if null
        setSelectedDates([start_date, end_date]);
    }

    function disableFutureDates(current) {
        return current && current > dayjs().startOf("day");
    }

    return (
        <ReservationAnalyticsContext.Provider
            value={{ selectedDates, setSelectedDates }}
        >
            <CustomHeader
                extraAfter={
                    <RangePicker
                        allowClear={false}
                        disabledDate={disableFutureDates}
                        defaultValue={[
                            dayjs(selectedDates[0]),
                            dayjs(selectedDates[1]),
                        ]}
                        value={[
                            dayjs(selectedDates[0]),
                            dayjs(selectedDates[1]),
                        ]}
                        className="dashboard-date-search"
                        onChange={handleDateChange}
                        format="MM/DD/YYYY"
                        presets={dateRangePresets.filter(
                            (preset) => preset.label !== "Today",
                        )}
                    />
                }
            />
            <div style={{ display: "flex", flexDirection: "column" }}>
                <Card className="margin-5" hoverable>
                    <Chart1 />
                </Card>
                <Card className="margin-5" hoverable>
                    <Chart2 />
                </Card>
            </div>
        </ReservationAnalyticsContext.Provider>
    );
}

export { ReservationAnalytics, ReservationAnalyticsContext };
